import { combineReducers } from 'redux'
import theme from './theme/themeSlice'
import auth from './auth'
import base from './base'
import locale from './locale/localeSlice'
import extension from './extension'
import currentPurchase from './currentPurchase'
import basket from './basket'
import cart from './cart-swik'
import loader from './loader'
import app from './appInstance/index'
import provider from './appProvider/index'
import dataWallet from './data-wallet-app/index'
import appProvider from './data-wallet-app/currentProviderSlice'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        extension,
        base,
        locale,
        basket,
        cart,
        currentPurchase,
        loader,
        dataWallet,
        appProvider,
        app,
        provider,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
